import { Icon } from '@iconify/react';
import { PATH_DASHBOARD } from '../../../routes/paths';


const navConfig = [
  {
    items: [
      { title: 'Dashboard', path: '/dashboard/home', icon: <Icon icon="mdi:view-dashboard-outline" /> },
      // { title: 'Product', path: PATH_DASHBOARD.product.product, icon: <Icon icon="mdi:cart-outline" /> },
      { title: 'Service', path: PATH_DASHBOARD.service.service, icon: <Icon icon="mdi:briefcase-outline" /> },
      { title: 'Staff', path: PATH_DASHBOARD.staff.staff, icon: <Icon icon="mdi:account-group-outline" /> },
      // { title: 'Category', path: PATH_DASHBOARD.category.category, icon: <Icon icon="mdi:tag-outline" /> },
      { title: 'Appointment', path: PATH_DASHBOARD.appointment.appointment, icon: <Icon icon="mdi:calendar-check-outline" /> },
      { title: 'Salary', path: PATH_DASHBOARD.salary.salary, icon: <Icon icon="mdi:currency-usd" /> },
      { title: 'Walking Customer', path: PATH_DASHBOARD.walking.walking, icon: <Icon icon="mdi:account-cash-outline" /> },

      {
        title: 'Calculate Salary',
        path: PATH_DASHBOARD.calculate_salary.calculate_salary,
        icon: <Icon icon="mdi:cash-multiple" /> // Option 1
      },

      { title: 'Attendance', path: PATH_DASHBOARD.attendance.attendance, icon: <Icon icon="mdi:check-circle-outline" /> },
      { title: 'Contacts', path: PATH_DASHBOARD.spell.spell, icon: <Icon icon="mdi:contacts-outline" /> },

    ],
  },

];

export default navConfig;
